module.exports = __webpack_public_path__ + "media/images/bg-cardboard-tape-d8af3a16ec56a0e5e508a9def41c826e.jpg";